<template>
  <div id="app">
    <LayoutDefault>
      <router-view></router-view>
    </LayoutDefault>
  </div>
</template>
<style>
@import "./main.scss";
</style>
<script>
import { CommonClass } from "@/mixins";
import LayoutDefault from "./layouts/default.vue";
import { UserService } from "@/services";
import sessionStorageUtils from "@/utils/session-storage";
import downTimeCalculator from "@/utils/downtime";
import { computed } from "vue";

export default {
  name: "App",
  mixins: [CommonClass],
  data() {
    return {
      downtimeObj: {},
    };
  },
  provide() {
    return {
      downtimeObj: computed(() => this.downtimeObj),
    };
  },
  async mounted() {
    const appId =
      new URLSearchParams(window.location.search).get("app_id") || "Unknown";
    sessionStorageUtils.setItem("appId", appId);
    const ChannelId = this.$__checkChannelId();
    sessionStorageUtils.setItem("ChannelId", ChannelId);
    const appCountry = this.$__checkAppCountry();
    sessionStorageUtils.setItem("appCountry", appCountry);

    try {
      const { data } = await UserService.getErrorCode();
      sessionStorageUtils.setItem("errorMsg", data);
    } catch (error) {
      console.log(error);
    }

    try {
      const downtimeFn = (key, updateObj) => {
        this.downtimeObj = { ...this.downtimeObj, [key]: updateObj };
      };
      const resp = await UserService.getSystemDowntime();
      if (resp.data) {
        downTimeCalculator(resp.data, downtimeFn);
      }
    } catch (e) {
      console.log(e);
    }
  },
  components: {
    LayoutDefault,
  },
};
</script>

<style></style>
